const WORDS = [
  "Never Frozen",
  "Greek Family Run",
  "Kali Orexi",
  "Gyros & Souvláki",
  "Fresh Seafood",
  "Golden Chips",
  "Philoxenia",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="marquee" className="py-8 lg:py-10 overflow-hidden" style={{ background: "var(--ice)" }}>
      <div className="relative flex whitespace-nowrap">
        <div className="flex items-center gap-16 animate-[marquee_36s_linear_infinite] pr-16">
          {row.map((w, i) => (
            <span key={i} className="flex items-center gap-16">
              <span className="font-display italic text-3xl lg:text-5xl text-[var(--navy)]">{w}</span>
              <span className="text-[var(--azure)] text-2xl">✦</span>
            </span>
          ))}
        </div>
        <div className="flex items-center gap-16 animate-[marquee_36s_linear_infinite] pr-16" aria-hidden>
          {row.map((w, i) => (
            <span key={i} className="flex items-center gap-16">
              <span className="font-display italic text-3xl lg:text-5xl text-[var(--navy)]">{w}</span>
              <span className="text-[var(--azure)] text-2xl">✦</span>
            </span>
          ))}
        </div>
      </div>
      <style>{`@keyframes marquee{from{transform:translateX(0)}to{transform:translateX(-100%)}}`}</style>
    </section>
  );
};
